import { defineMessages } from "react-intl";

import { node as clinicalData } from "src/modules/ktx/forms/basic-registration-data/clinical-data";
import { node as consents } from "src/modules/ktx/forms/basic-registration-data/consents";
import { node as liveDonorScreening } from "src/modules/ktx/forms/basic-registration-data/liveDonorScreening";
import { node as viralSerology } from "src/modules/ktx/forms/basic-registration-data/viral-serology";
import { node as waitingListData } from "src/modules/ktx/forms/basic-registration-data/waiting-list-data";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.basic_registration_data",
		defaultMessage: "Regisztrációs alapadatok"
	}
});

export const node: ParentNode = {
	id: "ktx-basic-registration-data",
	value: { type: "wizard", title: messages.title },
	children: [
		consents,
		clinicalData,
		viralSerology,
		waitingListData,
		liveDonorScreening
	]
};
